import React, { useEffect, useState } from "react";
import { PageLayout } from "../components/page-layout";
import { getAuctionListResource } from "../services/auction.service";
import { AuctionListTable } from "../components/auction/auction-list-table-simple";
import { Skeleton, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

export const AuctionListPageSimple = () => {
  const [auctionPlayers, setAuctionPlayers] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // New loading state
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const getAuctionList = async () => {
      setIsLoading(true); // Set loading to true before fetch
      const { data, error } = await getAuctionListResource();
      if (!isMounted) {
        return;
      }

      if (data) {
        setAuctionPlayers(data);
      }
      setIsLoading(false); // Set loading to false after fetch

      if (error) {
        setError(error);
      }
    };

    getAuctionList();

    return () => {
      isMounted = false;
    };
  }, []);

  if (error) {
    return (
      <PageLayout>
        <div className="content-layout">
          <div className="content__body">
            <p>Error: {error.message}</p>
          </div>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div className="content-layout">
        <div className="content__body">
          {isLoading ? (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 340 }} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={4} sx={{height:"50px"}}><Skeleton variant="text" width="100%" /></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.from(new Array(10)).map((_, index) => ( // Show 5 skeleton rows
                    <TableRow key={index}>
                      <TableCell sx={{ paddingLeft: '6px', paddingRight: '6px' }}><Skeleton variant="circular" width={40} height={40} /></TableCell>
                      <TableCell sx={{ paddingLeft: '6px', paddingRight: '6px' }}>
                        <Skeleton variant="text" width="70%" />
                        <Skeleton variant="text" width="50%" />
                      </TableCell>
                      <TableCell><Skeleton variant="text" width="60%" /></TableCell>
                      <TableCell><Skeleton variant="text" width="60%" /></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : auctionPlayers.length > 0 ? (
            <AuctionListTable players={auctionPlayers} />
          ) : (
            <p>No auction players found.</p>
          )}
        </div>
      </div>
    </PageLayout>
  );
};